import { MediaTextHorizontalLine } from 'Components/lines/media-text-horizontal-line/MediaTextHorizontalLine';
export default MediaTextHorizontalLine;
